import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Button from '@mui/material/Button';
import { useContext } from 'react';
import { FiltersContext } from '../../../pages/NRReportTabs/NRReportFilterContextWrapper';
import NRSBOMDrawer from '../../../pages/NRSBOMTable/NRSBOMDrawer/NRSBOMDrawer';
import { useTheme } from '@mui/material/styles';
import { CONSTANTS } from '../../../constants/constants';
import Typography from '@mui/material/Typography';

const { LOADING } = CONSTANTS.TABLE.MISCONFIGURATION_TABLE.MISCONFIGURATION_DETAIL_DRAWER;

export const confidenceAttr = 'fidelity';
const SbomNameFormatter = ({ value, column, row }) => {
  const theme = useTheme();
  const filtersContext = useContext(FiltersContext);
  
  // Check if FiltersContext is properly provided (not just default values)
  // Default context has openDrawer: null, but real context has boolean
  // Also check that drawerContent is an array (not null) to confirm it's the real context
  const isDrawerAvailable = filtersContext && 
                            filtersContext.setOpenDrawer && 
                            typeof filtersContext.setOpenDrawer === 'function' &&
                            filtersContext.openDrawer !== null && // Default context has null
                            Array.isArray(filtersContext.drawerContent); // Real context has array

  const handleOpenDrawer = () => {
    if (!isDrawerAvailable) {
      // Drawer not available, do nothing
      return;
    }
    
    const { setOpenDrawer, setDrawerContent, drawerContent, setDrawerTitle, drawerTitle, setHasBack } = filtersContext;
    !!drawerContent.length && setHasBack(true);
    setDrawerTitle([...drawerTitle, LOADING]);
    setDrawerContent([...drawerContent, <NRSBOMDrawer row={row} />]);
    setOpenDrawer(true);
  };

  return (
    <Button
      aria-label={isDrawerAvailable ? `Open details drawer for ${value}` : `Component name: ${value}`}
      onClick={handleOpenDrawer}
      disabled={!isDrawerAvailable}
      sx={{
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: isDrawerAvailable ? 'pointer' : 'default',
        px: 2,
        py: 1.5,
        width: '100%',
        height: '100%',
        minWidth: 'auto',
        textTransform: 'none',
        textAlign: 'left',
        backgroundColor: 'transparent',
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: 'transparent',
          boxShadow: 'none'
        },
        '&:focus-visible': {
          outline: '2px solid',
          outlineOffset: '2px',
          outlineColor: theme.palette.primary.main,
          backgroundColor: 'transparent'
        },
        '&:active': {
          backgroundColor: 'transparent',
          boxShadow: 'none'
        },
        '&:disabled': {
          cursor: 'default'
        }
      }}
      disableRipple
    >
      <Typography 
        variant="body2" 
        color={theme.palette.text.secondary} 
        sx={{ 
          textDecoration: isDrawerAvailable ? 'underline' : 'none'
        }}
      >
        {value || '-'}
      </Typography>
    </Button>
  );
};

export const NRSBOMNameProvider = props => <DataTypeProvider formatterComponent={SbomNameFormatter} {...props} />;
